import React, { Component } from 'react';
import Interweave from 'interweave';

import ShortTagFilter from './filters/ShortTagFilter'

class ContentNode extends Component {
  state = {
    nodes: {}
  }

  render() {
    return (
      this.props.nodes ? <Interweave
        filters={[new ShortTagFilter()]}
        content={this.props.nodes[this.props.path]}
      /> : ''
    )
  }
}

export default ContentNode



// WEBPACK FOOTER //
// ./src/components/ContentNode/ContentNode.js